<template>
    <div class="product-brand-card">
        <h1 class="product-brand-card__title">{{ store.meta.companyName }}</h1>
        <!-- 별점 -->
        <star-rating :star="store.meta.storeAverage"></star-rating>
        <!-- 점수 -->
        <span class="product-brand-card__score">{{ store.meta.storeAverage }}</span>
    </div>
</template>

<script>
import StarRating from "@/components/client/control/star-rating.vue";
export default {
    components: {
        StarRating
    },
    props: {
        store: { type: Object, default: null }
    },
}
</script>

<style lang="scss" scoped>
.product-lists{
    .product-brand-card { display: none; }
}
.product-brand-card{
    padding: 60px 40px 0; text-align: center;
    &__title { display: block; margin-bottom: 10px; line-height: 1; font-size: 26px; }
    &__score { display: inline-block; vertical-align: 1px; margin: 0 6px; line-height: 1; font-size: 15px; font-weight: 500; }
}
@media(max-width:1200px){
    .product-lists{
        .product-brand-card { display: block; padding: 0; }
    }
    .product-brand-card{
        padding: 30px 0 0;
        &__title { font-size: 18px; }
        &__score { font-size: 13px; }
    }
}
@media(max-width:768px){
    
}
</style>